import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tripcraftmx/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tripcraftmx/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tripcraftmx/frontend/src/app/[locale]/ClientBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/var/www/tripcraftmx/frontend/src/context/cartContext.tsx");
